import React, { useMemo, useContext, useEffect, useState } from 'react';
import { Container, Stack, Row, Col } from 'react-bootstrap';
import classNames from 'classnames';
import _ from 'lodash';

import { DimensionContext } from 'lb-components';
import {
  UseEvent,
  UseNavigation,
  UseSignIn,
  UseTableGames,
  UseUser,
} from 'lb-store/src/hooks';
import { BetradarLogoBnw, KironLogoBnw, HomeIcon } from '../../assets/icons';

import classes from './Navbar.module.scss';
import { Api, i18n, useTranslation } from 'lb-store';
import { Link, useNavigate } from 'react-router-dom';
import menuUtils from 'lb-store/src/helpers/menu';
import slotUtils from 'lb-store/src/helpers/slots';
import navItems from './navMenu.json';
import navItemsBranches from './navMenuBranches.json';

const vSportLogos = { betradar: BetradarLogoBnw, kiron: KironLogoBnw };

const Navbar = () => {
  const User = UseUser();
  const lang = i18n.language;
  const { t } = useTranslation();
  const signIn = UseSignIn();
  const { clientWidth } = useContext(DimensionContext);
  const { navigate } = UseNavigation();
  const tableGames = UseTableGames();
  const count = useMemo(() => {
    if (clientWidth < 550) return 3;
    if (clientWidth < 650) return 4;
    if (clientWidth < 720) return 5;
    if (clientWidth < 830) return 6;
    if (clientWidth < 890) return 7;
    if (clientWidth < 950) return 8;
    if (clientWidth < 1050) return 9;
    if (clientWidth < 1100) return 10;
    return 11;
  }, [clientWidth]);
  const getActiveTab = (route) => {
    const path = route.split('/');
    return '/'.concat(
      _.includes(['ka', 'en', 'ru'], path[1]) ? path[2] : path[1]
    );
  };
  //const routerNavigate = useNavigate();
  const [slotLabels, setSlotLabels] = useState([]);
  const [activeTab, setActiveTab] = useState(
    getActiveTab(window.location.pathname.concat(window.location.search))
  );
  const ev = UseEvent();
  useEffect(() => {
    const listener = ev.subscribe('location', (route) => {
      setActiveTab(getActiveTab(route));
    });
    Api.Slots.Labels().then((res) => {
      if (res.data?.data?.length > 0) {
        setSlotLabels(
          _.map(_.orderBy(res.data.data, ['sort'], ['asc']), (l) => ({
            id: l.id,
            label: l.name_en,
            play: ({ navigate, lang }) =>
              navigate('/'.concat(lang, `/slots/${l.id}`)),
          }))
        );
      }
    });
    return () => {
      listener.unsubscribe();
    };
  }, []);

  /*useEffect(() => {
    if(window.location.host === 'reactive.lider-bet.com' || window.location.host === 'react.lider-bet.com:3000'){
      navItems.push({
        "label": "JetX",
        "url": null,
        "badge": null,
        "action": {
          "type": "play",
          "params": {
            "gameId": "jetX"
          }
        }
      })
    }
  }, [navItems]);*/

  return (
    <Container fluid={'gigantic'}>
      <nav className={classes.nav}>
        <Link
          to={'/'.concat(lang)}
          onClick={(e) => {
            if (e.ctrlKey) return;
            e.preventDefault();
            navigate('/'.concat(lang));
          }}
          className={classes.home}
          style={{ '--home-icon': `url(${HomeIcon})` }}
        />
        <div className={classes.list}>
          {(User?.User?.data?.branch ? navItemsBranches : navItems).map(
            (item, index) =>
              index < count && (
                <div
                  className={classes.listItem}
                  data-menu={
                    !!(item.children?.length > 0 || item.url === '/slots')
                  }
                  key={index}
                >
                  <Link
                    to={item.url ? '/'.concat(lang, item.url) : '#'}
                    onClick={(e) => {

                      if (e.ctrlKey) return;
                      e.preventDefault();
                      menuUtils.openNavLink(item, lang, User, signIn);
                    }}
                    /*className={classes.link}*/
                    className={classNames(
                      classes.link,
                      ((activeTab === '/virtualSport' &&
                        item.url === '/vSport') ||
                        activeTab === item.url) &&
                        classes.active
                    )}
                    style={{
                      cursor: item.url ? 'pointer' : 'default',
                    }}
                  >
                    {t(item.label)}
                  </Link>
                  {(item.children?.length > 0 || item.url === '/slots') && (
                    <div
                      className={classNames({
                        [classes.dropdown]: true,
                        [classes.vsport]: item.url === '/vSport',
                        [classes.slots]: item.url === '/slots',
                      })}
                    >
                      {item.url === '/vSport' ? (
                        <>
                          {_.map(
                            _.groupBy(item.children, 'group'),
                            (values, key) => (
                              <Col key={key}>
                                <header
                                  style={{
                                    backgroundImage: `url(${vSportLogos[key]})`,
                                  }}
                                />
                                <Stack as={'ul'} className={classes.list}>
                                  {values.map((i, idx) => (
                                    <li
                                      key={idx}
                                      onClick={() => {
                                        menuUtils.openNavLink(
                                            i,
                                            lang,
                                            User,
                                            signIn
                                        )
                                      }
                                      }
                                    >
                                      <span>{t(i.label).toUpperCase()}</span>
                                    </li>
                                  ))}
                                </Stack>
                              </Col>
                            )
                          )}
                        </>
                      ) : (
                        <ul className={classes.list}>
                          {item.url === '/slots' && (
                            <li
                              onClick={() =>
                                navigate(`/${lang}/page/slots-tournaments`)
                              }
                            >
                              <span style={{ color: 'var(--bs-primary)' }}>
                                {'slots tournament'.toUpperCase()}
                              </span>
                            </li>
                          )}

                          {_.map(
                            item.url === '/slots' ? slotLabels : item.children,
                            (i, index) => (
                              <li
                                key={index}
                                onClick={() => {
                                  item.url !== '/slots'
                                    ? menuUtils.openNavLink(
                                        i,
                                        lang,
                                        User,
                                        signIn
                                      )
                                    : navigate(`/${lang}/slots/${i.id}`);
                                }}
                              >
                                <span
                                  className={
                                    slotUtils.NEW_CATEGORY_IDS.includes(i.id)
                                      ? classes.new
                                      : null
                                  }
                                >
                                  {item.url === '/slots'
                                    ? i.label.toUpperCase()
                                    : lang === 'ka'
                                    ? t(i.label)
                                    : t(i.label).toUpperCase()}
                                </span>
                              </li>
                            )
                          )}
                        </ul>
                      )}
                    </div>
                  )}
                </div>
              )
          )}
          {count < 11 && (
            <div className={classes.listItem}>
              <span className={classes.link}>{t('მეტი')}</span>
              <div className={classes.dropdown}>
                <ul className={classes.list}>
                  {_.slice(
                    User?.User?.data?.branch ? navItemsBranches : navItems,
                    count
                  ).map((item, index) => (
                    <li
                      key={index}
                      onClick={() =>

                        menuUtils.openNavLink(
                          item,
                          lang,
                          User,
                          signIn
                        )
                      }
                    >
                      <span>{t(item.label)}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
      </nav>
    </Container>
  );
};
export default Navbar;
